export default {
  english: {
    label: 'Share on WhatsApp',
  },
  french: {
    label: 'Partager sur WhatsApp',
  },
  arabic: {
    label: 'انشر على WhatsApp',
  },
  hebrew: {
    label: 'שתף בוואטסאפ',
  },
  persian: {
    label: 'در واتس اپ به اشتراک بگذارید',
  },
}
